var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    [
      _c(
        "LoadingOverlay",
        {
          attrs: {
            loading:
              _vm.$apollo.queries.contractor.loading ||
              _vm.$apollo.queries.contractorDetails.loading,
            hasData: _vm.isContractorExists && !_vm.permissionDenied,
            customPlaceholderMessage:
              "You have no permissions to access the user's private data",
          },
        },
        [
          _vm.isContractorExists
            ? _c(
                "div",
                [
                  _vm.areAllObjectsWithIdLoaded
                    ? _c("ContractorHeader", {
                        attrs: {
                          contractorUser: _vm.contractor.user,
                          contractorFullName: _vm.contractorFullName,
                          contractorUserId: _vm.contractor.user.id,
                          avatar: _vm.contractor.user.avatar,
                          country: _vm.contractor.user.profile.country,
                          state: _vm.contractor.user.profile.state,
                          city: _vm.contractor.user.profile.city,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "optionalInfo",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-wrap mb-4 items-flex-start justify-between space-y-1 sm:self-center sm:space-y-0 mt-0.5",
                                    },
                                    [
                                      _c(
                                        "div",
                                        [
                                          _vm.isDisableNotificationsIconShown
                                            ? _c("NotificationOffIcon", {
                                                staticClass:
                                                  "w-6 h-6 text-gray-400 mr-2",
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      !_vm.contractor.user.confirmed &&
                                      _vm.areAllObjectsWithIdLoaded
                                        ? _c("ContractorResendInvitation", {
                                            attrs: {
                                              showSmallButton: false,
                                              companyId: _vm.company.id,
                                              contractorId: _vm.contractor.id,
                                              invitedByUserId:
                                                _vm.currentUser.id,
                                              givenName:
                                                _vm.contractor.user.given_name,
                                              familyName:
                                                _vm.contractor.user.family_name,
                                              isPending: _vm.isPendingInvite(),
                                            },
                                            on: {
                                              invitationResent: function (
                                                $event
                                              ) {
                                                return _vm.setInvitationSentStatus()
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex flex-row justify-end items-center",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "actionButton mx-2.5 w-6 h-6 flex items-center justify-center cursor-pointer",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.handleCopy(
                                                    _vm.contractor.id
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "Tooltip",
                                                {
                                                  staticClass:
                                                    "flex items-center ml-1",
                                                  attrs: {
                                                    variant:
                                                      _vm.TooltipVariants.DARK,
                                                    title: "Copy Profile Link",
                                                    tooltipClasses:
                                                      "contrcAligment",
                                                    placement: "top",
                                                    arraowClass: "hideArrow",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "p-1 hoverBack -ml-7",
                                                      on: {
                                                        mouseover: function (
                                                          $event
                                                        ) {
                                                          _vm.isHoveredCopy = true
                                                        },
                                                        mouseout: function (
                                                          $event
                                                        ) {
                                                          _vm.isHoveredCopy = false
                                                        },
                                                      },
                                                    },
                                                    [
                                                      !_vm.isHoveredCopy
                                                        ? _c("CopyLink")
                                                        : _vm._e(),
                                                      _vm.isHoveredCopy
                                                        ? _c("CopyLinkHover")
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "button",
                                            {
                                              staticClass: "customMessage",
                                              on: {
                                                click: _vm.message,
                                                mouseover: function ($event) {
                                                  _vm.isHoveredChat = true
                                                },
                                                mouseout: function ($event) {
                                                  _vm.isHoveredChat = false
                                                },
                                              },
                                            },
                                            [
                                              !_vm.isHoveredChat
                                                ? _c("MessageIcon", {
                                                    staticClass: "w-4 h-4",
                                                  })
                                                : _vm._e(),
                                              _vm.isHoveredChat
                                                ? _c("MessageIconHover", {
                                                    staticClass: "w-4 h-4",
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm.isContractorDeleted
                                            ? _c("UiButtonMessage", {
                                                attrs: {
                                                  processing: _vm.processing,
                                                  label: "add light-gray",
                                                  buttonClass:
                                                    "customAddCompany",
                                                },
                                                on: {
                                                  click:
                                                    _vm.addContractorToCompany,
                                                },
                                              })
                                            : _c(
                                                "button",
                                                {
                                                  staticClass: "customDelete",
                                                  on: {
                                                    click: _vm.deleteContractor,
                                                    mouseover: function (
                                                      $event
                                                    ) {
                                                      _vm.isHoveredDelete = true
                                                    },
                                                    mouseout: function (
                                                      $event
                                                    ) {
                                                      _vm.isHoveredDelete = false
                                                    },
                                                  },
                                                },
                                                [
                                                  !_vm.isHoveredDelete
                                                    ? _c("DeleteIcon", {
                                                        staticClass: "w-4 h-4",
                                                      })
                                                    : _vm._e(),
                                                  _vm.isHoveredDelete
                                                    ? _c("DeleteIconHover", {
                                                        staticClass: "w-4 h-4",
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                          _c("ToggleFavorite", {
                                            staticClass: "customFav",
                                            attrs: {
                                              currentUserId: _vm.currentUser.id,
                                              didLike:
                                                _vm.contractor.user
                                                  .favorited_by_users.length >
                                                0,
                                              contractorUserId:
                                                _vm.contractor.user.id,
                                              favorites:
                                                _vm.contractor.user
                                                  .favorited_by_users,
                                            },
                                            on: {
                                              updated: function ($event) {
                                                return _vm.$apollo.queries.contractor.refetch()
                                              },
                                            },
                                          }),
                                          _c("ToggleDNUFlag", {
                                            staticClass: "customDNU",
                                            attrs: {
                                              contractorUserId:
                                                _vm.contractor.user.id,
                                              isDNUFlagged: _vm.isDNUFlagged,
                                            },
                                            on: {
                                              updated:
                                                _vm.refreshContractorData,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.showManagementAddContractorInfoModal
                                    ? _c("ManagementAddContractorInfo", {
                                        attrs: {
                                          managementAddedInfoMode: _vm
                                            .managementAddedInfoMode.jobTitle
                                            ? _vm.managementAddedInfoMode
                                            : _vm.managementAddedInfoModeRate,
                                          userId: _vm.contractor?.user.id,
                                          profileByManagement:
                                            _vm.contractorDetail
                                              ?.contractor_by_pk?.user
                                              ?.profile ||
                                            _vm.contractor?.user?.profile,
                                        },
                                        on: {
                                          close: () => {
                                            _vm.showManagementAddContractorInfoModal = false
                                            Object.assign(
                                              _vm.managementAddedInfoModeRate,
                                              { rate: false }
                                            )
                                            Object.assign(
                                              _vm.managementAddedInfoMode,
                                              { jobTitle: false }
                                            )
                                          },
                                          refreshContractor: () => {
                                            _vm.$apollo.queries.contractorDetails.refetch()
                                          },
                                          refetchProfileByManagement: () => {
                                            _vm.processing = true
                                            _vm.$apollo.queries.contractor.refetch()
                                            _vm.$apollo.queries.contractorDetails.refetch()
                                            _vm.processing = false
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "userInfo",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "mb-1 flex flex-row flex-wrap items-center",
                                    },
                                    [
                                      _vm.getCompany
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-lg leading-normal text-primary-black pr-1",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.getCompany) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.isEmailUnconfirmed() &&
                                      !_vm.isPendingInvite()
                                        ? _c("Badge", {
                                            attrs: {
                                              color: _vm.BadgeColor.WARNING,
                                              value: _vm.emailStatusText,
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isPendingInvite()
                                        ? _c("Badge", {
                                            attrs: {
                                              color: _vm.BadgeColor.WARNING,
                                              value: _vm.inviteNotSent,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-row items-center mb-4 relative",
                                    },
                                    [
                                      !!_vm.contractorRates
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-lg leading-normal text-primary-black pr-1",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.contractorRates) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-lg leading-normal text-primary-black pr-1",
                                            },
                                            [_vm._v(" No Rate Set ")]
                                          ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "ml-2 border-none newEditButton",
                                          on: {
                                            click: () => {
                                              _vm.showManagementAddContractorInfoModal = true
                                              _vm.managementAddedInfoModeRate.rate = true
                                            },
                                            mouseover: function ($event) {
                                              _vm.isHoveredEditRate = true
                                            },
                                            mouseout: function ($event) {
                                              _vm.isHoveredEditRate = false
                                            },
                                          },
                                        },
                                        [
                                          !_vm.isHoveredEditRate
                                            ? _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: 17,
                                                    height: 17,
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M15.7375 1.51328C15.0531 0.828906 13.9469 0.828906 13.2625 1.51328L12.3219 2.45078L15.3813 5.51016L16.3219 4.56953C17.0063 3.88516 17.0063 2.77891 16.3219 2.09453L15.7375 1.51328ZM6.3875 8.38828C6.19687 8.57891 6.05 8.81328 5.96562 9.07266L5.04063 11.8477C4.95 12.1164 5.02188 12.4133 5.22188 12.6164C5.42188 12.8195 5.71875 12.8883 5.99062 12.7977L8.76562 11.8727C9.02188 11.7883 9.25625 11.6414 9.45 11.4508L14.6781 6.21953L11.6156 3.15703L6.3875 8.38828ZM4 2.83516C2.34375 2.83516 1 4.17891 1 5.83516V13.8352C1 15.4914 2.34375 16.8352 4 16.8352H12C13.6562 16.8352 15 15.4914 15 13.8352V10.8352C15 10.282 14.5531 9.83516 14 9.83516C13.4469 9.83516 13 10.282 13 10.8352V13.8352C13 14.3883 12.5531 14.8352 12 14.8352H4C3.44688 14.8352 3 14.3883 3 13.8352V5.83516C3 5.28203 3.44688 4.83516 4 4.83516H7C7.55312 4.83516 8 4.38828 8 3.83516C8 3.28203 7.55312 2.83516 7 2.83516H4Z",
                                                      fill: "#070823",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isHoveredEditRate
                                            ? _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: 17,
                                                    height: 17,
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M15.7375 1.51328C15.0531 0.828906 13.9469 0.828906 13.2625 1.51328L12.3219 2.45078L15.3813 5.51016L16.3219 4.56953C17.0063 3.88516 17.0063 2.77891 16.3219 2.09453L15.7375 1.51328ZM6.3875 8.38828C6.19687 8.57891 6.05 8.81328 5.96562 9.07266L5.04063 11.8477C4.95 12.1164 5.02188 12.4133 5.22188 12.6164C5.42188 12.8195 5.71875 12.8883 5.99062 12.7977L8.76562 11.8727C9.02188 11.7883 9.25625 11.6414 9.45 11.4508L14.6781 6.21953L11.6156 3.15703L6.3875 8.38828ZM4 2.83516C2.34375 2.83516 1 4.17891 1 5.83516V13.8352C1 15.4914 2.34375 16.8352 4 16.8352H12C13.6562 16.8352 15 15.4914 15 13.8352V10.8352C15 10.282 14.5531 9.83516 14 9.83516C13.4469 9.83516 13 10.282 13 10.8352V13.8352C13 14.3883 12.5531 14.8352 12 14.8352H4C3.44688 14.8352 3 14.3883 3 13.8352V5.83516C3 5.28203 3.44688 4.83516 4 4.83516H7C7.55312 4.83516 8 4.38828 8 3.83516C8 3.28203 7.55312 2.83516 7 2.83516H4Z",
                                                      fill: "#1A7BEE",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-row items-center mb-7 relative",
                                    },
                                    [
                                      !!_vm.getOccupation
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-lg leading-normal text-primary-black pr-1",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(_vm.getOccupation) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "text-lg leading-normal text-primary-black pr-1",
                                            },
                                            [_vm._v(" No Job Title Set ")]
                                          ),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "ml-2 border-none newEditButton",
                                          on: {
                                            click: () => {
                                              _vm.showManagementAddContractorInfoModal = true
                                              _vm.managementAddedInfoMode.jobTitle = true
                                            },
                                            mouseover: function ($event) {
                                              _vm.isHoveredEditJobTitle = true
                                            },
                                            mouseout: function ($event) {
                                              _vm.isHoveredEditJobTitle = false
                                            },
                                          },
                                        },
                                        [
                                          !_vm.isHoveredEditJobTitle
                                            ? _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: 17,
                                                    height: 17,
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M15.7375 1.51328C15.0531 0.828906 13.9469 0.828906 13.2625 1.51328L12.3219 2.45078L15.3813 5.51016L16.3219 4.56953C17.0063 3.88516 17.0063 2.77891 16.3219 2.09453L15.7375 1.51328ZM6.3875 8.38828C6.19687 8.57891 6.05 8.81328 5.96562 9.07266L5.04063 11.8477C4.95 12.1164 5.02188 12.4133 5.22188 12.6164C5.42188 12.8195 5.71875 12.8883 5.99062 12.7977L8.76562 11.8727C9.02188 11.7883 9.25625 11.6414 9.45 11.4508L14.6781 6.21953L11.6156 3.15703L6.3875 8.38828ZM4 2.83516C2.34375 2.83516 1 4.17891 1 5.83516V13.8352C1 15.4914 2.34375 16.8352 4 16.8352H12C13.6562 16.8352 15 15.4914 15 13.8352V10.8352C15 10.282 14.5531 9.83516 14 9.83516C13.4469 9.83516 13 10.282 13 10.8352V13.8352C13 14.3883 12.5531 14.8352 12 14.8352H4C3.44688 14.8352 3 14.3883 3 13.8352V5.83516C3 5.28203 3.44688 4.83516 4 4.83516H7C7.55312 4.83516 8 4.38828 8 3.83516C8 3.28203 7.55312 2.83516 7 2.83516H4Z",
                                                      fill: "#070823",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.isHoveredEditJobTitle
                                            ? _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    xmlns:
                                                      "http://www.w3.org/2000/svg",
                                                    width: 17,
                                                    height: 17,
                                                  },
                                                },
                                                [
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M15.7375 1.51328C15.0531 0.828906 13.9469 0.828906 13.2625 1.51328L12.3219 2.45078L15.3813 5.51016L16.3219 4.56953C17.0063 3.88516 17.0063 2.77891 16.3219 2.09453L15.7375 1.51328ZM6.3875 8.38828C6.19687 8.57891 6.05 8.81328 5.96562 9.07266L5.04063 11.8477C4.95 12.1164 5.02188 12.4133 5.22188 12.6164C5.42188 12.8195 5.71875 12.8883 5.99062 12.7977L8.76562 11.8727C9.02188 11.7883 9.25625 11.6414 9.45 11.4508L14.6781 6.21953L11.6156 3.15703L6.3875 8.38828ZM4 2.83516C2.34375 2.83516 1 4.17891 1 5.83516V13.8352C1 15.4914 2.34375 16.8352 4 16.8352H12C13.6562 16.8352 15 15.4914 15 13.8352V10.8352C15 10.282 14.5531 9.83516 14 9.83516C13.4469 9.83516 13 10.282 13 10.8352V13.8352C13 14.3883 12.5531 14.8352 12 14.8352H4C3.44688 14.8352 3 14.3883 3 13.8352V5.83516C3 5.28203 3.44688 4.83516 4 4.83516H7C7.55312 4.83516 8 4.38828 8 3.83516C8 3.28203 7.55312 2.83516 7 2.83516H4Z",
                                                      fill: "#1A7BEE",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "icons",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col lg:flex-row gap-8",
                                    },
                                    [
                                      _c("div", [
                                        _c(
                                          "div",
                                          { staticClass: "flex flex-row" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "flex font-400 customlineH text-sm mb-1 text-storm-gray w-24",
                                              },
                                              [_vm._v(" Location: ")]
                                            ),
                                            _vm.location !== null
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "font-normal text-sm text-badgeBlue hover:text-badgeBlue no-underline maxContentWidth truncate customLineH",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.location) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.location === null &&
                                            _vm.locationByManagement.length > 0
                                              ? _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _vm.locationByManagement
                                                        .length > 0
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "block underline font-normal text-sm text-lightGreen maxContentWidth truncate hover:text-badgeBlue no-underline customLineH",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement?.[0]
                                                                      ?.address
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement?.[0]
                                                                      ?.address &&
                                                                      _vm
                                                                        .locationByManagement?.[0]
                                                                        ?.city &&
                                                                      ","
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement?.[0]
                                                                      ?.city
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement?.[0]
                                                                      ?.state &&
                                                                      _vm
                                                                        .locationByManagement?.[0]
                                                                        ?.city &&
                                                                      ","
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement?.[0]
                                                                      ?.state
                                                                  ) +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement?.[0]
                                                                      ?.state &&
                                                                      _vm
                                                                        .locationByManagement?.[0]
                                                                        ?.city &&
                                                                      _vm
                                                                        .locationByManagement?.[0]
                                                                        ?.country &&
                                                                      ","
                                                                  ) +
                                                                  " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .locationByManagement?.[0]
                                                                      ?.country
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.location === null &&
                                            _vm.locationByManagement.length ===
                                              0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-normal text-sm text-primary-black customlineH",
                                                  },
                                                  [_vm._v(" n/a ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex flex-row" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "flex font-400 customlineH text-sm mb-1 text-storm-gray w-24",
                                              },
                                              [_vm._v(" Website: ")]
                                            ),
                                            _vm.website !== null
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "text-badgeBlue block hover:text-badgeBlue text-sm maxContentWidth truncate font-normal no-underline customLineH",
                                                    attrs: {
                                                      href: _vm.website,
                                                      target: "”_blank”",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(_vm.website) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            (_vm.website === null ||
                                              _vm.website === ``) &&
                                            _vm.websitesByManagement !== null
                                              ? _c("div", [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "flex flex-row items-center",
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          staticClass:
                                                            "text-light-green hover:text-badgeBlue maxContentWidth text-sm truncate font-normal no-underline customLineH",
                                                          attrs: {
                                                            href: _vm
                                                              .websitesByManagement?.[0]
                                                              ?.name,
                                                            target: "_blank",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .websitesByManagement?.[0]
                                                                  ?.name
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm.website === null &&
                                            _vm.websitesByManagement === null
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-normal text-sm text-primary-black customlineH",
                                                  },
                                                  [_vm._v(" n/a ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flex flex-row sm:truncate",
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "flex font-400 customlineH text-sm mb-1 text-storm-gray w-24",
                                              },
                                              [_vm._v(" Email: ")]
                                            ),
                                            _vm.contractor.user.private_data
                                              .email
                                              ? _c("MailTo", {
                                                  staticClass:
                                                    "text-badgeBlue hover:text-badgeBlue maxContentWidth truncate text-sm font-normal customLineH",
                                                  attrs: {
                                                    email:
                                                      _vm.contractor.user
                                                        .private_data.email,
                                                  },
                                                })
                                              : _vm._e(),
                                            !_vm.contractor.user.private_data
                                              .email &&
                                            _vm.emailByManagement.length > 0
                                              ? _c(
                                                  "div",
                                                  _vm._l(
                                                    _vm.emailByManagement,
                                                    function (email) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: email.name,
                                                          staticClass:
                                                            "flex flex-row items-center",
                                                        },
                                                        [
                                                          _c("MailTo", {
                                                            staticClass:
                                                              "text-light-green hover:text-badgeBlue maxContentWidth truncate text-sm font-normal customLineH",
                                                            attrs: {
                                                              email: email.name,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            !_vm.contractor.user.private_data
                                              .email &&
                                            _vm.emailByManagement.length === 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-normal text-sm text-primary-black customlineH",
                                                  },
                                                  [_vm._v(" n/a ")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex flex-row" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "flex font-400 customlineH text-sm mb-1 text-storm-gray w-24",
                                              },
                                              [_vm._v(" Work Phone: ")]
                                            ),
                                            _vm.phoneNumber !== null
                                              ? _c("PhoneTo", {
                                                  staticClass:
                                                    "block font-normal text-sm text-badgeBlue maxContentWidth hover:text-badgeBlue no-underline customLineH",
                                                  attrs: {
                                                    phone: _vm.phoneNumber,
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm.phoneNumber === null &&
                                            _vm.phoneByManagement.length > 0
                                              ? _c(
                                                  "div",
                                                  _vm._l(
                                                    _vm.phoneByManagement,
                                                    function (phone) {
                                                      return _c(
                                                        "span",
                                                        {
                                                          key: phone.name,
                                                          staticClass:
                                                            "flex flex-row items-center",
                                                        },
                                                        [
                                                          _c("PhoneTo", {
                                                            staticClass:
                                                              "block font-normal text-sm maxContentWidth text-lightGreen hover:text-badgeBlue no-underline customLineH",
                                                            attrs: {
                                                              phone: phone.name,
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              : _vm._e(),
                                            _vm.phoneNumber === null &&
                                            _vm.phoneByManagement.length === 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "font-normal text-sm text-primary-black customlineH",
                                                  },
                                                  [_vm._v(" n/a ")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "flex flex-row" },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "flex font-400 customlineH text-sm mb-1 text-storm-gray w-24",
                                              },
                                              [_vm._v(" Active Clients: ")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "font-normal text-sm text-primary-black customlineH",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(_vm.activeProjects) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass: "flex flex-row",
                                        }),
                                      ]),
                                      _c(
                                        "div",
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mr-3 flex flex-row items-center text-sm mb-1",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "flex font-400 leading-6 h-5 w-24 min-w-24 text-sm text-storm-gray truncate max-w-36",
                                                },
                                                [_vm._v(" Rating: ")]
                                              ),
                                              _vm.calculateAverageRating() !== 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex flex-row",
                                                    },
                                                    [
                                                      _c("star-rating", {
                                                        attrs: {
                                                          rating:
                                                            _vm.calculateAverageRating(),
                                                          increment: 0.1,
                                                          "show-rating": true,
                                                          "active-color":
                                                            "#FED054",
                                                          starSize: 15,
                                                          "max-rating": 5,
                                                          readOnly: "",
                                                        },
                                                      }),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-gray-new text-sm font-normal ml-0.5",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (" +
                                                              _vm._s(
                                                                _vm.calculateTotal()
                                                              ) +
                                                              ") "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "font-normal text-low-xs text-primary-black",
                                                    },
                                                    [_vm._v(" n/a ")]
                                                  ),
                                            ]
                                          ),
                                          _c("PageHeadIcon", {
                                            attrs: {
                                              content: `${Math.round(
                                                _vm.contractorDetails
                                                  .totalHoursTracked / 3600
                                              ).toLocaleString()} hrs`,
                                              title: "Hours Worked:",
                                            },
                                          }),
                                          _c("PageHeadIcon", {
                                            attrs: {
                                              content: _vm.createdDate,
                                              title: "Joined:",
                                            },
                                          }),
                                          _vm.addedById !== 0
                                            ? _c("PageHeadIcon", {
                                                attrs: {
                                                  content: _vm.fullName,
                                                  title: "Added By:",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm.maxAvailableHours
                                            ? _c("PageHeadIcon", {
                                                attrs: {
                                                  content: `${_vm.maxAvailableHours} hrs/week`,
                                                  title: "Max Hours:",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "actions",
                              fn: function () {
                                return undefined
                              },
                              proxy: true,
                            },
                            {
                              key: "document",
                              fn: function () {
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-col gap-4 items-start",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "bg-white rounded-lg shadow-md h-64 document-sec",
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "border-b border-gray-200 px-3 pt-4 pb-1",
                                            },
                                            [
                                              _c(
                                                "nav",
                                                { staticClass: "-mb-px flex" },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass:
                                                        "whitespace-no-wrap pb-1 border-b-2 border-transparent font-normal text-lg leading-5 focus:outline-none text-primary-black focus:text-gray-700 focus:border-gray-300 hover:text-gray-700 hover:border-secondary-black",
                                                      attrs: { href: "#" },
                                                    },
                                                    [_vm._v(" All Documents ")]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c("ResumeSidebar", {
                                            attrs: {
                                              managerUserId:
                                                _vm.contractor?.user.id,
                                              contractorUserId:
                                                _vm.contractor?.user.id,
                                              contractorFullName:
                                                _vm.contractorFullName,
                                              currentUser: _vm.currentUser,
                                              companyId: _vm.company.id,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2123738774
                        ),
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col md:flex-row mb-2 sm:mb-0 gap-6 w-full relative grid-rows-2 grid-flow-col gap-4",
                    },
                    [
                      this.currentUser.role === `MANAGER`
                        ? _c("TabsWithRoutes", {
                            staticClass: "bg-white mt-7 routeBlock",
                            attrs: {
                              routeTabs: _vm.routeTabsManager,
                              id: "resourcesTabs",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "mr-1.5" }, [
                                        _vm._v("About"),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                _vm.showVisits
                                  ? {
                                      key: _vm.routes.CONTRACTOR_DETAILS_VISITS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Visits")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.visitsTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.showProject
                                  ? {
                                      key: _vm.routes
                                        .CONTRACTOR_DETAILS_PROJECTS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Clients")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.projectsTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.doumentsTotal &&
                                _vm.resId &&
                                _vm.doumentsTotal > 0
                                  ? {
                                      key: _vm.routes
                                        .CONTRACTOR_DETAILS_DOCUMENTS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Documents")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.doumentsTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                {
                                  key: _vm.routes.CONTRACTOR_DETAILS_REVIEWS,
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "mr-1.5" }, [
                                        _vm._v("Reviews"),
                                      ]),
                                      _vm.showReview
                                        ? _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.reviewsTotal,
                                              info: "",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                                this.notesTotal > 0
                                  ? {
                                      key: _vm.routes.CONTRACTOR_DETAILS_NOTES,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v(" Notes")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.notesTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                {
                                  key: _vm.routes.CONTRACTOR_DETAILS_INFO,
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "mr-1.5" }, [
                                        _vm._v(" Additional info"),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          })
                        : _c("TabsWithRoutes", {
                            staticClass: "bg-white mt-7 routeBlock",
                            attrs: {
                              routeTabs: _vm.routeTabsAdmin,
                              id: "resourcesTabs",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: _vm.routes.CONTRACTOR_DETAILS_ABOUT,
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "mr-1.5" }, [
                                        _vm._v("About"),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                                _vm.showVisits
                                  ? {
                                      key: _vm.routes.CONTRACTOR_DETAILS_VISITS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Visits")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.visitsTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.showProject
                                  ? {
                                      key: _vm.routes
                                        .CONTRACTOR_DETAILS_PROJECTS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Clients")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.projectsTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                _vm.doumentsTotal &&
                                _vm.resId &&
                                _vm.doumentsTotal > 0
                                  ? {
                                      key: _vm.routes
                                        .CONTRACTOR_DETAILS_DOCUMENTS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Documents")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.doumentsTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                {
                                  key: _vm.routes.CONTRACTOR_DETAILS_REVIEWS,
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "mr-1.5" }, [
                                        _vm._v("Reviews"),
                                      ]),
                                      _vm.showReview
                                        ? _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.reviewsTotal,
                                              info: "",
                                            },
                                          })
                                        : _vm._e(),
                                    ]
                                  },
                                  proxy: true,
                                },
                                this.managersTotal > 0
                                  ? {
                                      key: _vm.routes
                                        .CONTRACTOR_DETAILS_MANAGERS,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v("Managers")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.managersTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                this.notesTotal > 0
                                  ? {
                                      key: _vm.routes.CONTRACTOR_DETAILS_NOTES,
                                      fn: function () {
                                        return [
                                          _c(
                                            "span",
                                            { staticClass: "mr-1.5" },
                                            [_vm._v(" Notes")]
                                          ),
                                          _c("TabNotificationBubble", {
                                            attrs: {
                                              notification: _vm.notesTotal,
                                              info: "",
                                            },
                                          }),
                                        ]
                                      },
                                      proxy: true,
                                    }
                                  : null,
                                {
                                  key: _vm.routes.CONTRACTOR_DETAILS_INFO,
                                  fn: function () {
                                    return [
                                      _c("span", { staticClass: "mr-1.5" }, [
                                        _vm._v(" Additional info"),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                      _c("ReviewSidebar", {
                        staticClass: "reviewBlock fix-scrollbar",
                        attrs: {
                          currentUserId: _vm.currentUser.id,
                          contractorFullName: _vm.contractorFullName,
                          currentUserRole: _vm.currentUser.role,
                          contractorId: _vm.contractor.id,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.areAllObjectsWithIdLoaded
                    ? _c("router-view", {
                        attrs: {
                          company: _vm.company,
                          contractor: _vm.contractor,
                          contractorId: _vm.contractor.id,
                          contractorUserId: _vm.contractor.user.id,
                          currentUserId: _vm.currentUser.id,
                          contractorFullName: _vm.contractorFullName,
                          currentUserRole: _vm.currentUser.role,
                          currentUser: _vm.currentUser,
                          companyId: _vm.company.id,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm.removeFromCompanyModalShown && _vm.areAllObjectsWithIdLoaded
        ? _c("RemoveFromCompanyModal", {
            attrs: {
              contractorId: _vm.contractorId,
              companyId: _vm.company.id,
            },
            on: { close: _vm.closeRemoveFromCompanyModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }